import AppContentView from "_lib/AppContentView";
import React, { useMemo } from "react";
import {
  StyledAppLayout,
  StyledAppLayoutContent,
  StyledAppLayoutContentScrollbar,
  StyledAppLayoutMain,
} from "./index.styled";
import AppSideBar from "./AppSideBar";
import PropTypes from "prop-types";
import { useIsMobile } from "_hooks";
import AppHeader from "./AppHeader";
import AppMobileMenu from "./AppMobileMenu";
import { getIsTradeRoute } from "_helpers";
import { useLocation } from "react-router-dom";

const Layout = (props) => {
  const { routes, routesConfig } = props;

  const isMobile = useIsMobile();
  const { pathname } = useLocation();

  const additionalClassName = useMemo(() => {
    return getIsTradeRoute(pathname) ? "bottom-zero" : "";
  }, [pathname]);

  return (
    <StyledAppLayout>
      {isMobile && <AppHeader />}
      <StyledAppLayoutMain className={additionalClassName}>
        {!isMobile && <AppSideBar routesConfig={routesConfig} />}
        <StyledAppLayoutContent>
          <StyledAppLayoutContentScrollbar>
            <AppContentView routes={routes} />
          </StyledAppLayoutContentScrollbar>
        </StyledAppLayoutContent>
      </StyledAppLayoutMain>
      <AppMobileMenu routesConfig={routesConfig} />
    </StyledAppLayout>
  );
};

Layout.propTypes = {
  routes: PropTypes.array.isRequired,
  routesConfig: PropTypes.array.isRequired,
};

export default Layout;
